import CalendarOutlined from '@ant-design/icons/CalendarOutlined'
import { Tag } from 'antd'
import dayjs from 'dayjs'
import { InspectionCardTitleContent } from 'features/inbox/components/inspectionCards/InspectionCardTitleContent'
import { InspectionMetricsDisplay } from 'features/inbox/components/inspectionCards/InspectionMetricsDisplay'
import { StatusBadgeComponent } from 'features/inbox/components/inspectionCards/StatusBadgeComponent'
import { isRecentInspection } from 'features/inbox/components/inspectionCards/utils'
import {
  CardSubtitle,
  CardTitle,
  DateBadge,
  InspectionTypeBadge,
  MetricsContainer,
  OverviewHeader,
  StatusBadgesContainer,
} from 'features/inbox/components/shared/styledElements'
import {
  EnrichedGeckoInspection,
  InspectionStatus,
} from 'features/inbox/types/types'
import { INSPECTION_DATE_FORMAT } from 'features/inbox/utils/date'
import React, { memo } from 'react'

interface InspectionOverviewContentProps {
  inspection: EnrichedGeckoInspection
  unitColor: string
  withMetricsMargin?: boolean
}

const InspectionOverviewContentBase: React.FC<
  InspectionOverviewContentProps
> = ({ inspection, unitColor, withMetricsMargin = false }) => {
  const inspectionData = inspection.data

  if (!inspectionData) {
    return null
  }

  return (
    <>
      <OverviewHeader>
        <CardTitle level={5}>
          <InspectionCardTitleContent inspection={inspection} />
          {inspectionData.date && (
            <CardSubtitle>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}>
                <DateBadge>
                  <CalendarOutlined />
                  {dayjs(inspectionData.date).format(INSPECTION_DATE_FORMAT)}
                </DateBadge>
                {inspectionData.unitName && (
                  <Tag color={unitColor} variant='solid'>
                    {inspectionData.unitName as string}
                  </Tag>
                )}
                {isRecentInspection(inspectionData.date.toString()) && (
                  <Tag color='blue'>Recent</Tag>
                )}
              </div>
            </CardSubtitle>
          )}
        </CardTitle>
        <StatusBadgesContainer>
          {(inspectionData.inspection_type as string) && (
            <InspectionTypeBadge>
              {inspectionData.inspection_type as string}
            </InspectionTypeBadge>
          )}
          <StatusBadgeComponent
            status={inspectionData.derivedStatus as InspectionStatus}
          />
        </StatusBadgesContainer>
      </OverviewHeader>
      <MetricsContainer $withMargin={withMetricsMargin}>
        <InspectionMetricsDisplay inspection={inspection} />
      </MetricsContainer>
    </>
  )
}

export const InspectionOverviewContent = memo(InspectionOverviewContentBase)
